
class ContratoItem {
  "id": Number = 0;
  "numeroContrato": string = "";
  "codigoFornecedorSap": Number = 0;
  "grupo": String = "";
  "idSku": String = "";
  "centroDistribuicaoDestino": Number = 0;
  "anoRef": Number = 0;
  "quantidade": Number = 0;
  "d_E_L_E_T_E": boolean = false;
  "criadoEm": Date = new Date();
  "excluidoEm": Date = new Date();
  "gerouForecast": boolean = false;
  "contratoSap": string = "";
  origem = '';
  projeto = '';
}

export default ContratoItem;

